export default __webpack_public_path__ + "static/media/75t.2c069657.jpg";